<template>
    <div v-if="can" class="pb-32">
        <settings-heading
            :title="$t('settings.billing_details.title')"
            :description="$t('settings.billing_details.description')"
        />

        <billing-fields/>
    </div>
    <error-403 v-else></error-403>
</template>

<script>
import {mapState} from 'pinia';
import {useMainStore} from '../../state/store';
import Error403 from '../../components/ui/Error403.vue';
import 'vue-range-slider/dist/vue-range-slider.css'
import Input from "../../components/forms/Input";
import BillingFields from "../../components/settings/BillingFields";
import SettingsHeading from "../../components/ui/SettingsHeading.vue";

export default {
    components: {
        SettingsHeading,
        BillingFields,
        'simple-input': Input,
        'error-403': Error403,
    },
    data: function () {
        return {
            form: null
        }
    },
    computed: {
        ...mapState(useMainStore, ['currentCompany']),
        can() {
            return this.$can('settings.finance')
        },
    },
}
</script>
